import CompanyProfile from "./pages/CompanyProfile"
import Account from "../accounts/pages/Account"

export default [
  {
    path: '/profile',
    name: 'CompanyProfile',
    component: CompanyProfile,
    props: true,
    meta: {
      permissions: ['LOGIN'],
      breadcrumbs: [
        {name: 'Profile', to: {name: 'CompanyProfile', params: ['cid']}}
      ]
    }
  },
  {
    path: '/profile/:cid/accounts/:uid?',
    name: 'AdminAccountDetails',
    component: Account,
    props: true,
    meta: {
      permissions: ['LOGIN'],
      breadcrumbs: [
        {name: 'Profile', to: {name: 'CompanyProfile', params: ['cid']}},
        {name: 'User', to: {name: 'Account', params: ['cid', 'uid']}}
      ]
    }
  }
]



// WEBPACK FOOTER //
// ./src/company/routes.js